import type { Product } from '@virginexperiencedays/products';
import { getFullSku, getProductUrl } from '../../../../utils/product';
import { addToBasket as DY } from '../../../tracking/dynamicyield/events';
import { addToBasket as FB } from '../../../tracking/fb/events';
import { addToBasket as GTM } from '../../../tracking/gtm/interactions/addToBasket';
import { trackAddedToCart as trackKlaviyoAddedToCart } from '../../../tracking/klaviyo';
import { getDimension6, getSingleSupplierName } from '../../../tracking/utils';

type BasketItemType = {
  sku: string;
  qty: number;
  price: number;
  slug: string;
  title: string;
  rrp: number;
  rowTotal: number;
  url: string;
  imageUrl: string;
  categories: string[];
  isCollectionProduct: boolean;
};

export const track = async ({
  product,
  qty,
  totalAmount,
  basketItems,
}: {
  product: Product;
  qty: number;
  totalAmount: number;
  basketItems: BasketItemType[];
}) => {
  try {
    const {
      id,
      title,
      slug,
      sku,
      promocode,
      price,
      categories = [],
      categoryHierarchy: { lvl0 = null } = { lvl0: null },
      suppliers = [],
      isCollectionProduct,
    } = product;
    const currency = 'GBP';

    const { displayPrice = null } = price ?? {};

    GTM({
      name: title,
      sku,
      brand: getSingleSupplierName(suppliers, isCollectionProduct),
      category: lvl0,
      price: displayPrice,
      productId: id?.toString(),
      dimension6: getDimension6({ price }),
      quantity: qty,
      currency,
      promocode,
    });

    DY({ sku, promocode, price: displayPrice, qty, basketItems });

    trackKlaviyoAddedToCart({
      title,
      slug,
      sku: getFullSku({ sku, promocode }),
      isCollectionProduct,
      categories,
      rrp: product.price?.rrp ?? 0,
      displayPrice: product.price?.displayPrice ?? 0,
      imageUrl: product.media?.mainImage?.url ?? '',
      url: getProductUrl({ slug, isCollectionProduct }),
      totalAmount,
      qty,
      items: basketItems?.map(({ price, ...item }) => ({
        ...item,
        displayPrice: price,
      })),
    });

    await FB({ name: title, category: lvl0, sku, price: displayPrice, qty, currency });
  } catch (e) {
    console.error(e);
  }
};
